// extracted by mini-css-extract-plugin
module.exports = {"lifeAtVahakRow":"LifeatVahak_lifeAtVahakRow__8PZCV"};